import { Controller } from "@hotwired/stimulus";
import axios from "axios";
import { toggleSections } from "../section_appearance";
import * as Sentry from "@sentry/browser";

export default class ApplyVoucher extends Controller {
  initialize() {
    this.professionalId = this.data.get("professionalId");
    this.projectId = this.data.get("projectId");
    this.auth = this.data.get("auth");
    this.countryCode = this.data.get("countryCode");
    this.locale = this.data.get("locale");
  }

  async submitCode() {
    const discountCode = document.getElementById("discount-input").value;
    try {
      await this.checkDiscountCodeValidity(discountCode);
    } catch (error) {
      console.error("Error submitting discount code:", error);
    }
  }

  async fetchVoucherValidation(discountCode) {
    try {
      return await axios({
        method: "post",
        url: `/${this.countryCode}/${this.locale}/vouchers/validate_voucher`,
        data: {
          voucher: {
            discount_code: discountCode,
            professional_id: this.professionalId,
            project_id: this.projectId,
          },
        },
        headers: {
          "X-CSRF-Token": this.auth,
          Accept: "text/vnd.turbo-stream.html, text/html, application/json",
        },
      });
    } catch (error) {
      Sentry.captureException(error);
    }
  }

  async checkDiscountCodeValidity(discountCode) {
    try {
      const response = await this.fetchVoucherValidation(discountCode);

      // extract the voucher ID from the turbo response
      const voucherIdMatch = response.data.match(/data-voucher-id="([^"]*)"/);
      const voucherId = voucherIdMatch ? parseInt(voucherIdMatch[1]) : null;
      // render the Turbo Stream message
      await Turbo.renderStreamMessage(response.data);

      if (voucherId) {
        location.reload();
      }
    } catch (error) {
      console.error("Error validating discount code:", error);
      return null;
    }
  }

  removeVoucher() {
    document.getElementById("discount-input").value = null; // reset the input feild
    toggleSections(false, "voucher-code-is-valid", "discount-code-error");
    toggleSections(true, "voucher-not-applied");
  }
}
